import getMailboxRegionalConfiguration from '../services/getMailboxRegionalConfiguration';
import setRegionalConfiguration from '../data/mutators/setRegionalConfiguration';
import loadTimeZoneOptions from './loadTimeZoneOptions';

export default function loadRegionalOptions() {
    return Promise.all([
        getMailboxRegionalConfiguration().then(options => {
            setRegionalConfiguration(
                options.SupportedCultures,
                options.SupportedShortDateFormats,
                options.SupportedShortTimeFormats
            );
        }),
        loadTimeZoneOptions(),
    ]);
}
